import { useContext, useEffect } from 'react'
import { Colon } from '@nv/components'
import { ModalContext } from '@nv/contexts'
import { useTranslation } from 'react-i18next'
import styles from './AuthAppInfo.module.scss'

export const AuthAppInfo = () => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('auth.authApp.modal.header'))
    setBtns([{ text: t('buttons.ok'), onClick: onClose, variant: 'secondary' }])
  }, [])

  return (
    <div className={styles['container']}>
      <span className={styles['title']}>{t('auth.authApp.modal.title')}</span>
      <span className={styles['sub-heading']}>{t('auth.authApp.modal.hereToFind')}</span>
      <span className={styles['heading']}>
        Google Authenticator
        <Colon />
      </span>
      <span className={styles['sub-heading']}>{t('auth.authApp.modal.google')}</span>
      <span className={styles['heading']}>
        Microsoft Authenticator
        <Colon />
      </span>
      <span className={styles['sub-heading']}>{t('auth.authApp.modal.availableOnBoth')}</span>
      <span className={styles['heading']}>{t('auth.authApp.modal.other')}</span>
      <span className={styles['sub-heading']}>{t('auth.authApp.modal.otherDirectives')}</span>
      <span className={styles['sub-heading']}>{t('auth.authApp.modal.downloadSteps')}</span>
    </div>
  )
}
